module.exports = __webpack_public_path__ + "img/reserve_icon.d1e3a57b.svg";